import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro'
import Footer from '../../components/Footer'
import OurTeams from './OurTeams'


const Blog = () => {
  return (
   <Layout>
      <Intro />
      <OurTeams/>
      <Footer/>
    </Layout>
  )
}

export default Blog